import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCreditCard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"credit-card-1, card, payment"} maskId="square-filled-radius-0-stroke-1-IconCreditCard1"><path d="M2 4H22V9.5H2V4Z" fill="currentColor"/><path d="M2 10.5V20H22V10.5H2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCreditCard1;
